export default __webpack_public_path__ + "media/images/features/yado/top_bottom_sp-a45a78611460f6ab7e47494a4fa8fc86.png";